import { createFileRoute } from '@tanstack/react-router';
import { PlaceCategoryForm } from '../../../features/places/components/place-category-form';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/place-categories/new')({
  staticData: { breadcrumb: 'Новая' },
  component: NewPlaceCategoryPage,
});

function NewPlaceCategoryPage() {
  return (
    <div>
      <PageHeader title="Новая категория мест" />
      <PlaceCategoryForm mode="create" />
    </div>
  );
}
